import { useState, useEffect } from 'react';

export interface GetPostsType {
	data: any;
	loading: boolean;
	maxPages: number;
}

export const GetPosts = (url: string): GetPostsType => {
	const [data, setData] = useState<any>();
	const [loading, setLoading] = useState<boolean>(true);
	const [maxPages, setMaxPages] = useState(3);

	useEffect(() => {
		const fetchPosts = async (url: string) => {
			try {
				const apiResponse = await fetch(url);
				const json = await apiResponse.json();
				setData(json);
				setMaxPages(json?.max_pages);
			} catch (error) {
				console.error('Fetch error:', error);
			}
			setLoading(false);
		};

		fetchPosts(url);
	}, [url]);

	return { loading, data, maxPages };
};
